import React, { Component } from "react";
import PropTypes from "prop-types";
import { Droppable, Draggable } from "react-beautiful-dnd";
import Variable from "../Variable";
import SVG from "../../../../../../components/SVG";

import styles from "./variables-group.module.scss";

class VariablesGroup extends Component {
  static defaultProps = {
    isCombineEnabled: false
  };

  renderGroup = dropProvided => {
    const { group, groupId, onRemoveVariable, onRemoveGroup } = this.props;

    return (
      <div className={styles["variables-group"]} ref={dropProvided.innerRef}>
        {group.map((variable, index) => (
          <Draggable
            key={`selected-variable-${variable.id}`}
            draggableId={`${variable.id}`}
            index={index}
          >
            {dragProvided => (
              <div
                className="d-flex"
                {...dragProvided.dragHandleProps}
                {...dragProvided.draggableProps}
                ref={dragProvided.innerRef}
              >
                {variable.name && (
                  <Variable
                    variable={variable}
                    onRemoveVariable={onRemoveVariable}
                    showOperator={index + 1 < group.length}
                  />
                )}
              </div>
            )}
          </Draggable>
        ))}
        <button
          type="button"
          className={styles["variables-group-remove"]}
          onClick={() => {
            onRemoveGroup(groupId);
          }}
        >
          <SVG.Close width={20} height={20} />
        </button>
        {dropProvided.placeholder}
      </div>
    );
  };

  render() {
    const { listId, listType, listLength, isCombineEnabled } = this.props;

    return (
      <>
        <Droppable
          droppableId={`${listId}`}
          type={listType}
          direction="horizontal"
          isCombineEnabled={isCombineEnabled}
        >
          {dropProvided => (
            <div {...dropProvided.droppableProps}>
              {this.renderGroup(dropProvided)}
            </div>
          )}
        </Droppable>
        {listId + 1 < listLength ? (
          <div className={styles["variables-group-operator"]}>AND</div>
        ) : null}
      </>
    );
  }
}

VariablesGroup.propTypes = {
  group: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  groupId: PropTypes.number.isRequired,
  listId: PropTypes.number.isRequired,
  listType: PropTypes.string.isRequired,
  listLength: PropTypes.number.isRequired,
  isCombineEnabled: PropTypes.bool,
  onRemoveVariable: PropTypes.func.isRequired,
  onRemoveGroup: PropTypes.func.isRequired
};

export default VariablesGroup;
